import { Component, computed, inject } from '@angular/core';

import { PartnersService } from '../../services';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss'],
  standalone: true,
})
export class PartnersComponent {
  protected service = inject(PartnersService);
  protected partners = toSignal(this.service.list(), { initialValue: [] });
  protected hidden = computed(() => this.partners().length === 0);
}
